import { Image } from '@vinted/web-ui'

import { InfluencerTipsCardModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

export const TipsSectionCard = ({
  title,
  description,
  image,
  index,
}: InfluencerTipsCardModel & { index: number }) => (
  <article className="influencer__tips-card" data-testid="influencer__tips-card">
    <div className="influencer__tips-card-image">
      <Image
        src={image.x2Url}
        srcset={`${image.x1Url} 1x, ${image.x2Url} 2x, ${image.x3Url} 3x`}
        scaling="fill"
        loading="lazy"
        testId={`tips-card-image-${index}`}
      />
    </div>
    <h3 className="influencer__tips-card-title">{title}</h3>
    <p className="influencer__tips-card-description">{description}</p>
  </article>
)
